/**
 * @generated SignedSource<<d6cb50d6b82e5b5f7d4b51d004543f20>>
 * @relayHash 485e58bcec6a33793659965477bacb0b
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/576.0.0-2026-09-10T12:11:52.928Z/verifyEmailHandlerQuery

import { ConcreteRequest } from 'relay-runtime';
export type verifyEmailHandlerQuery$variables = {
  buyerId?: string | null;
  email?: string | null;
  hasBuyerId: boolean;
};
export type verifyEmailHandlerQuery$data = {
  readonly viewer: {
    readonly user?: {
      readonly profile: {
        readonly email: string | null;
      } | null;
    } | null;
    readonly userExistsMetadata: {
      readonly emailOnly: boolean | null;
      readonly hasPassword: boolean | null;
    } | null;
  };
};
export type verifyEmailHandlerQuery = {
  response: verifyEmailHandlerQuery$data;
  variables: verifyEmailHandlerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "buyerId"
},
v1 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "email"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasBuyerId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "buyerId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Profile",
  "kind": "LinkedField",
  "name": "profile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "email",
    "variableName": "email"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailOnly",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPassword",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "verifyEmailHandlerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "hasBuyerId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v3/*:: as any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "alias": null,
            "args": (v5/*:: as any*/),
            "concreteType": "UserExistsMetadataType",
            "kind": "LinkedField",
            "name": "userExistsMetadata",
            "plural": false,
            "selections": [
              (v6/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "verifyEmailHandlerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "hasBuyerId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v3/*:: as any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/),
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "alias": null,
            "args": (v5/*:: as any*/),
            "concreteType": "UserExistsMetadataType",
            "kind": "LinkedField",
            "name": "userExistsMetadata",
            "plural": false,
            "selections": [
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/576.0.0-2026-09-10T12:11:52.928Z/verifyEmailHandlerQuery",
    "metadata": {},
    "name": "verifyEmailHandlerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a5ca83631de3a0f9b8d2c2be6441740d";

export default node;
